import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Box,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import usePremiumBacklink from '../hooks/usePremiumBacklink';

const TermsModal = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { termsModalOpen, closeTermsModal } = usePremiumBacklink();

  return (
    <Dialog
      open={termsModalOpen}
      onClose={closeTermsModal}
      maxWidth="md"
      fullWidth
      fullScreen={isMobile}
      PaperProps={{
        style: { maxHeight: isMobile ? '100vh' : '80vh' }
      }}
    >
      <DialogTitle
        disableTypography
        style={{
          display: 'flex',
          alignItems: 'center',
          borderBottom: '1px solid #e0e0e0',
          paddingBottom: 8,
          padding: isMobile ? '12px 16px' : '16px 24px'
        }}
      >
        <Typography variant={isMobile ? "subtitle1" : "h6"} style={{ flex: 1, fontSize: isMobile ? '1rem' : '1.25rem' }}>
          Terms and Conditions of Sale
        </Typography>
        <IconButton onClick={closeTermsModal} size="small" aria-label="Close terms modal">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent style={{ padding: isMobile ? '16px 12px' : '20px 24px', overflowY: 'auto' }}>
        <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
          WHEREAS, the Client wishes to engage Hennessey Group, Inc. (Hennessey Group) to provide web design and
          marketing services requested. Hennessey Group agrees to provide these and additional services for compensation
          and otherwise in accordance with the terms and conditions contained herein.

        </Typography>

        {/* 1. TERM AND TERMINATION */}
        <Box mb={3}>
          <Typography variant="h6" gutterBottom style={{ fontSize: '1.1rem', fontWeight: 600 }}>
            1. Term and Termination
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            1.  This Agreement shall be eective as of the Eective Date, and services performed hereunder by Hennessey Group will be in accordance with the terms set forth on the Work Order Form(s).
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            2.  This Agreement may be terminated by either party upon written notice to the other, if the other party breaches any material obligation provided hereunder and the breaching party fails to cure such breach within thirty (30) days of receipt of the notice. This Agreement may be terminated by
            Hennessey Group  (i) immediately if Client fails to pay any fees hereunder; or (ii) if Client fails to cooperate with Hennessey Group or hinders their ability to perform the Search Engine Optimization
            (SEO) or other services hereunder.
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            3.  This Agreement may be terminated without cause, for any reason by either party, sixty (60) days aer
            providing written notice to the other party.
          </Typography>
        </Box>

        {/* 2. SERVICES */}
        <Box mb={3}>
          <Typography variant="h6" gutterBottom style={{ fontSize: '1.1rem', fontWeight: 600 }}>
            2. Services
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            1.  Hennessey Group agrees to provide Client with services as described in the Work Order Form of this Agreement. Hennessey Group is authorized to use specific keywords and/or phrases as determined for development, improving the ranking of, and/or positioning the contents of the Clientʼs URL(s) (as set forth in the Work Order Form) in search engines and /or directories. SEO, Web Development, and
            Pay Per Click (PPC) Advertising services are intended to provide the Client with preferential position in selected search engines and report results on an ongoing and timely basis.
            Document Ref: NFOML-Z8R79-A3SQE-YEOSE Page 23 of 28
            Hennessey Digital | 5200 Lankershim Blvd., #170, North Hollywood, CA  91601
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            2.  Hennessey Group retains all ownership of development and content work provided (to include, but not limited to: website development and video creation) until all conditions of the Statement of Work (SOW) have been completed AND Client has paid in full per the terms of the Agreement. Hennessey
            Group grants the Client a license to use all work during the development phases. Licenses will be revoked immediately upon failure to pay any fees in accordance with the terms of this Agreement.
          </Typography>
        </Box>

        {/* 3. FEES */}
        <Box mb={3}>
          <Typography variant="h6" gutterBottom style={{ fontSize: '1.1rem', fontWeight: 600 }}>
            3. Fees
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            Client agrees to pay Hennessey Group the fee(s) as stated in the Work Order Form. Fees will be
            collected by ACH debit, or to the clientʼs credit card on file in the event that ACH debit is unsuccessful. Unless
            otherwise noted on the Work Order Form, payment terms for all fees are as set forth below:

          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            1.  For SEO Services (standard and video): 100% of one monthʼs fees due upon execution of this
            Agreement. Ongoing fees for services will be billed on the monthly anniversary date of the Execution
            Date.
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            2.  For Design and Marketing retainer services: 100% of retainer plus any additional charged hours due
            on the first of the month preceding the delivered service month.
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            3.  For Website Redesigns and Rebuilds: 50% of the fees due upon execution of this Agreement. Balance
            of fees due upon Client approval and delivery of final product.
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            4.  For PPC: 100% of advertising costs will be charged to the Clientʼs credit card on file with the
            advertising network (e.g., Google or Facebook). Hennessey Group will charge a sliding scale
            Management Fee as a percentage of the total PPC spend. Charges will be invoiced the month aer
            incurred.
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            5.  Credit card charges: All payments to Hennessey Group via credit card will include an additional 3.5%
            processing fee.
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            6.  Annual Fee Adjustment: Client agrees that the fees listed in the Scope of Work will be adjusted once
            per year, starting on the one-year anniversary of the start of the engagement and continuing each
            year on this anniversary. An automatic increase of 4% will be applied to each line item listed in the
            Scope of Work each year.
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            7.  Late Fees: All payments not received by the Invoice Due Date may be subject to a 10% late fee.
          </Typography>
        </Box>

        {/* 4. CLIENT RESPONSIBILITIES */}
        <Box mb={3}>
          <Typography variant="h6" gutterBottom style={{ fontSize: '1.1rem', fontWeight: 600 }}>
            4. Client Responsibilities
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            For the purpose of providing these services, Client agree:
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            • To provide Hennessey Group with FTP access to its websites for uploading new pages and making changes
            for the purpose of SEO, Web Development, and PPC Services.
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            • That if Hennessey Group recommends that Clientʼs website(s) add more textual content for the purpose of
            improving performance in search, Client will provide additional content in electronic format for the purpose
            of creating additional web pages.
          </Typography>
        </Box>

        {/* 5. CLIENT ACKNOWLEDGEMENTS */}
        <Box mb={3}>
          <Typography variant="h6" gutterBottom style={{ fontSize: '1.1rem', fontWeight: 600 }}>
            5. Client Acknowledgements
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            Client understands, acknowledges, and agrees that:
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            1.  Hennessey Group has no control over the policies of search engines or directories with respect to the
            type of sites and/or content that they accept now or in the future. Customerʼs web site(s) may be
            excluded from any search engine or directory at any time at the sole discretion of the search engine
            or directory entity.
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            2.  Some search engines and directories may take as long as two (2) to four (4) months, and in some
            cases longer, aer submission to list Clientʼs website(s).
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            3.  Occasionally, search engines and directories will stop accepting submissions for an indefinite period
            of time.
            Document Ref: NFOML-Z8R79-A3SQE-YEOSE Page 24 of 28
            Hennessey Digital | 5200 Lankershim Blvd., #170, North Hollywood, CA  91601
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            4.  Some search engines and directories oer expedited listing services for a fee. Hennessey Group
            encourages Client to take advantage of these expedited services. Client is responsible for all
            expedited service fees in addition to an Hennessey Group service charge of 17.5% unless otherwise
            noted in the Work Order Form.
          </Typography>
        </Box>

        {/* 6. CHANGES TO WEBSITE */}
        <Box mb={3}>
          <Typography variant="h6" gutterBottom style={{ fontSize: '1.1rem', fontWeight: 600 }}>
            6. Changes to Website
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            Hennessey Group is not responsible for changes made to Clientʼs website(s) by Client
            or by other parties that adversely aect the search engine or directory rankings of Clientʼs website(s).
          </Typography>
        </Box>

        {/* 7. OWNERSHIP */}
        <Box mb={3}>
          <Typography variant="h6" gutterBottom style={{ fontSize: '1.1rem', fontWeight: 600 }}>
            7. Ownership
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            All assets developed by Hennessey Group for Client—including written text, web pages, images,
            and videos—become the permanent property of Client in perpetuity. Hennessey Group&apos;s proprietary
            technology and SEO techniques remain the property of Hennessey Group. Nothing in this Agreement will
            function to transfer any other of either party&apos;s intellectual property rights to the other party.
          </Typography>
        </Box>

        {/* 8. LIMITATIONS OF SCOPE */}
        <Box mb={3}>
          <Typography variant="h6" gutterBottom style={{ fontSize: '1.1rem', fontWeight: 600 }}>
            8. Limitations of Scope
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            Hennessey Group will not be responsible for work that is beyond the scope of
            services set forth in this service agreement. Changes to the scope of this Agreement to include additional
            services must be approved by both parties
          </Typography>
        </Box>

        {/* 9. ADDITIONAL SERVICES */}
        <Box mb={3}>
          <Typography variant="h6" gutterBottom style={{ fontSize: '1.1rem', fontWeight: 600 }}>
            9. Additional Services
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            Additional services not listed herein or in the Work Order Form or Price Sheet will
            receive a separate proposal upon request.
          </Typography>
        </Box>

        {/* 10. INTERFERENCE */}
        <Box mb={3}>
          <Typography variant="h6" gutterBottom style={{ fontSize: '1.1rem', fontWeight: 600 }}>
            10. Interference
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            1.  During the course of the Agreement and for a period of two (2) years immediately following the
            expiration or termination of the Agreement for any reason, whether with or without good cause or far any or no cause, at the option of either party, with or without notice, neither Hennessey Group nor the Client will, either directly or indirectly, interfere with the contracts and relationships, or prospective contracts and relationships, of the other party, including, but not limited to, Hennessey
            Groupʼs or Clientʼs respective customer or client contracts and relationships. At the end of such two
            (2) year term, either party may begin to work with the other partyʼs former or current customers or
            client relationships upon first obtaining written permission from the other party.
          </Typography>
        </Box>

        {/* 11. DISCLAIMER OF WARRANTIES */}
        <Box mb={3}>
          <Typography variant="h6" gutterBottom style={{ fontSize: '1.1rem', fontWeight: 600 }}>
            11. Disclaimer of All Other Warranties
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            Hennessey Group does not warrant that SEO or other services will
            meet the customerʼs expectations or requirements. The entire risk as to the quality and performance is with
            the customer. Except as otherwise specified in this agreement, Hennessey Group, LLC provides its services
            “as is” and without warranty of any kind. The parties agree that (a) the limited warranties set forth in this
            section are the sole and exclusive warranties provided by each party, and (b) each party disclaims all other
            warranties, express or implied, including but not limited to, the implied warranties of merchantability and
            fitness for a particular purpose, relating to this agreement, performance or inability to perform under this
            agreement, the content, and each partyʼs computing and distribution reason unenforceable, then that
            provision shall be deemed severable from this agreement and shall not aect the validity and enforceability
            of any remaining provisions.
          </Typography>
        </Box>

        {/* 12. LIMITED LIABILITY */}
        <Box mb={3}>
          <Typography variant="h6" gutterBottom style={{ fontSize: '1.1rem', fontWeight: 600 }}>
            12. Limited Liability
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            In no event shall Hennessey Group be liable to Client for any indirect, special, exemplary
            or consequential damages, including any implied warranty of merchantability or fitness for a particular
            purpose or implied warranties arising from the course of dealing or course of performance, lost profits,
            whether or not foreseeable or alleged to be based on breach of warranty, contract, negligence or strict
            Document Ref: NFOML-Z8R79-A3SQE-YEOSE Page 25 of 28
            Hennessey Digital | 5200 Lankershim Blvd., #170, North Hollywood, CA  91601liability, arising under this agreement, loss of data, or any performance under this agreement, even if such
            party has been advised of the possibility of such damages and notwithstanding the failure of essential
            purpose of any limited remedy provided herein. Hennessey Group makes no warranty of any kind, whether or
            not express or implied, with regard to any third party products, third party content or any software,
            equipment, or hardware obtained from third parties.
          </Typography>
        </Box>

        {/* 13. NO REFUNDS */}
        <Box mb={3}>
          <Typography variant="h6" gutterBottom style={{ fontSize: '1.1rem', fontWeight: 600 }}>
            13. No Refunds
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            All collected fees shall not be refundable under any circumstances, including but not limited to
            the termination of this Agreement by either party for any reason.
          </Typography>
        </Box>

        {/* 14. CLIENT REPRESENTATIONS */}
        <Box mb={3}>
          <Typography variant="h6" gutterBottom style={{ fontSize: '1.1rem', fontWeight: 600 }}>
            14. Client Representations
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            Client makes the following representations and warranties for the benefit of
            Hennessey Group:

          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            1.  Client represents to Hennessey Group and unconditionally guarantees that any elements of text,
            graphics, photos, designs, trademarks, or other artwork furnished to Hennessey Group are owned by
            Client, or that Client has permission from the rightful owner to use each of these elements, and will
            hold harmless, protect, and defend Hennessey Group and its subcontractors.
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            2.  Client guarantees any elements of text, graphics, photos, designs, trademarks, or other artwork
            provided to Hennessey Group for inclusion on the website(s) are owned by Client, or that Client has
            received permission from the rightful owner(s) to use each of the elements, and will hold harmless,
            protect, and defend Hennessey Group and its subcontractors from any liability or suit arising from the
            use of such elements.
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            3.  From time to time governments enact laws and levy taxes and taris aecting Internet electronic
            commerce. Client agrees that the Client is solely responsible for complying with such laws, taxes, and
            taris, and will hold harmless, protect, and defend Hennessey Group and its subcontractors.
          </Typography>
        </Box>

        {/* 15. CONFIDENTIALITY */}
        <Box mb={3}>
          <Typography variant="h6" gutterBottom style={{ fontSize: '1.1rem', fontWeight: 600 }}>
            15. Confidentiality
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            The parties agree to hold each otherʼs Proprietary or Confidential Information in strict
            confidence. “Proprietary or Confidential Information” shall include, but is not limited to, written or oral
            contracts, trade secrets, know-how, business methods, business policies, memoranda, reports, records,
            computer retained information, notes, or financial information. Proprietary or Confidential Information shall
            not include any information which:
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6, marginLeft: '20px' }}>
            (i) is or becomes generally known to the public by any means other than a
            breach of obligations of the receiving party;
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6, marginLeft: '20px' }}>
            (ii) was previously known to the receiving party or rightly
            received by the receiving party from a third party;
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6, marginLeft: '20px' }}>
            (iii) is independently developed by the receiving party; or
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6, marginLeft: '20px' }}>
            (iv) is subject to disclosure under court order or other lawful process.
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            The parties agree not to make each
            otherʼs Proprietary and Confidential Information available in any form to any third party or to use each
            otherʼs Proprietary or Confidential Information for any purpose other than as specified in this Agreement.
            Each partyʼs proprietary or confidential information shall remain the sole and exclusive property of that
            party. The parties agree that in the event of use or disclosure by the other party other than as specifically
            provided for in this Agreement, the non-disclosing party may be entitled to equitable relief. Notwithstanding
            termination or expiration of this Agreement, Hennessey Group and Client acknowledge and agree that their
            obligations of confidentiality with respect to Proprietary or Confidential Information shall continue in eect
            indefinitely from the eective date set forth in the applicable Work Order Form.
            Document Ref: NFOML-Z8R79-A3SQE-YEOSE Page 26 of 28
            Hennessey Digital | 5200 Lankershim Blvd., #170, North Hollywood, CA  91601
          </Typography>
        </Box>

        {/* 16. FORCE MAJEURE */}
        <Box mb={3}>
          <Typography variant="h6" gutterBottom style={{ fontSize: '1.1rem', fontWeight: 600 }}>
            16. Force Majeure
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            Neither party will be liable for, or will be considered to be in breach of or default under this
            Agreement on account of, any delay or failure to perform as required by this Agreement as a result of any
            causes or conditions that are beyond such Partyʼs reasonable control and that such Party is unable to
            overcome through the exercise of commercially reasonable diligence. If any force majeure event occurs, the
            aected Party will give prompt written notice to the other Party and will use commercially reasonable eorts
            to minimize the impact of the event.
          </Typography>
        </Box>

        {/* 17. RELATIONSHIP OF PARTIES */}
        <Box mb={3}>
          <Typography variant="h6" gutterBottom style={{ fontSize: '1.1rem', fontWeight: 600 }}>
            17. Relationship of Parties
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            Hennessey Group, in rendering performance under this Agreement, shall be
            deemed an independent contractor and nothing contained herein shall constitute this arrangement to be
            employment, a joint venture, or a partnership.
          </Typography>
        </Box>

        {/* 18. NOTICE AND PAYMENT */}
        <Box mb={3}>
          <Typography variant="h6" gutterBottom style={{ fontSize: '1.1rem', fontWeight: 600 }}>
            18. Notice and Payment
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            Any notice required to be given under this Agreement shall be in writing and delivered
            personally to the other designated party at the addresses listed in the Work Order Form mailed by certified,
            registered, or express mail, return receipt requested or by Federal Express. Either party may change its
            address to which notice or payment is to be sent by written notice to the other under any provision of this
            paragraph.
          </Typography>
        </Box>

        {/* 19. SUCCESSORS & ASSIGNABILITY */}
        <Box mb={3}>
          <Typography variant="h6" gutterBottom style={{ fontSize: '1.1rem', fontWeight: 600 }}>
            19. Successors & Assignability
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            Client may not assign this Agreement or the rights and obligations to any
            third party without the prior express written approval of Hennessey Group. Hennessey Group reserves the
            right to assign subcontractors as needed to this project to ensure on-time completion. The provisions of the
            Agreement shall be binding upon and shall endure to the benefit of the Parties hereto, their heirs,
            administrators, and successors.
          </Typography>
        </Box>

        {/* 20. SEVERABILITY */}
        <Box mb={3}>
          <Typography variant="h6" gutterBottom style={{ fontSize: '1.1rem', fontWeight: 600 }}>
            20. Severability
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            If any term, clause, or provision hereof is held invalid or unenforceable by a court of
            competent jurisdiction, such invalidity shall not aect the validity or operation of any other term, clause, or
            provision and such invalid term, clause or provision shall be deemed to be severed from the Agreement.
          </Typography>
        </Box>

        {/* 21. INTEGRATION */}
        <Box mb={3}>
          <Typography variant="h6" gutterBottom style={{ fontSize: '1.1rem', fontWeight: 600 }}>
            21. Integration
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            This Agreement constitutes the entire understanding of the Parties, and revokes and
            supersedes all prior agreements between the Parties and is intended as a final expression of their Agreement.
            It shall not be modified or amended except in writing signed by the Parties hereto and specifically referring to
            this Agreement. This Agreement shall take precedence over any other documents which may conflict with
            this Agreement.
          </Typography>
        </Box>

        {/* 22. DISPUTES / ARBITRATION */}
        <Box mb={3}>
          <Typography variant="h6" gutterBottom style={{ fontSize: '1.1rem', fontWeight: 600 }}>
            22. Disputes
          </Typography>
          <Typography variant="body2" paragraph style={{ lineHeight: 1.6 }}>
            Client and Hennessey Group, LLC agree to make a good-faith eort to resolve any disagreement
            arising out of, or in connection with, this Agreement through negotiation. Should the Parties fail to resolve
            any such disagreement within ten (10) days, any controversy or claim arising out of or relating to this
            Agreement, including, without limitation, the interpretation or breach thereof, shall be submitted by either
            party to arbitration in Los Angeles County, California, and in accordance with the Commercial Arbitration
            Rules of the American Arbitration Association. The arbitration shall be conducted by one arbitrator, who shall
            be selected in the sole discretion of the American Arbitration Association administrator and licensed attorney
            with at least five (5) yearsʼ experience in the negotiation of technology contracts or litigation of technology
            disputes. The arbitrator shall have the power to enter any award that could be entered by a judge of the state
            courts of California sitting without a jury, and only such power, except that the arbitrator shall not have the
            power to award punitive damages, treble damages, or any other damages which are not compensatory, even
            Document Ref: NFOML-Z8R79-A3SQE-YEOSE Page 27 of 28
            Hennessey Digital | 5200 Lankershim Blvd., #170, North Hollywood, CA  91601if permitted under the laws of the State of California or any other applicable law. The arbitrator must issue his
            or her resolution of any dispute within thirty (30) days of the date the dispute is submitted for arbitration. The
            written decision of the arbitrator shall be final and binding and enforceable in any court.

          </Typography>
        </Box>


      </DialogContent>

      <DialogActions
        style={{
          padding: isMobile ? '12px 16px' : '16px 24px',
          borderTop: '1px solid #e0e0e0',
          backgroundColor: '#fafafa'
        }}
      >
        <Button
          onClick={closeTermsModal}
          color="primary"
          variant="contained"
          style={{
            minWidth: isMobile ? '100%' : 120,
            textTransform: 'none',
            fontWeight: 600,
          }}
        >
          I Understand
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TermsModal;